module.exports = __webpack_public_path__ + "assets/a96286267bd39c24bb7205b136aa6ab0.png";